module.exports = __webpack_public_path__ + "media/assets/Success-4b19624127e70074641906d39961ed6a.svg";